export const COLORS = {
    black: 'var(--color-soft-black)',
    violet: 'var(--color-brand-violet)',
    yellow: 'var(--color-brand-summer)',
    purple: 'var(--color-sembo-purple)',
    summer: 'var(--color-brand-summer)',
    coral: 'var(--color-brand-coral)',
    jungle: 'var(--color-brand-jungle)',
};
